export default __webpack_public_path__ + "static/media/CRS_7113-HDR-min.8249d87e.jpg";